module.exports = __webpack_public_path__ + "static/img/hot-dog.0769faf.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hot-dog.gif
// module id = vjCr
// module chunks = 4